import {
	ColorCode,
	CurrencyEnum,
	GlResourceTypeEnum,
	Media,
	ProductTypesEnum,
} from '@bondsports/types';
import { RCPaymentSettingStatus } from '@rcenter/core/models/Organization';
import { OrganizationAddress } from './address';
import { MediaItem } from './media';

export interface PaymentSettings {
	installments?: number;
	onlinePaymentEnabled?: boolean;
	allowCash?: boolean;
	paymentSettingStatus?: RCPaymentSettingStatus;
	bookingRequestOnly?: boolean;
	vettedCustomerDirectBooking?: boolean;
	terminalPaymentMethodCapture: {
		recurringBilling: TerminalPaymentMethodCaptureEnum;
		oneTimePurchase: TerminalPaymentMethodCaptureEnum;
	};
}

export enum TerminalPaymentMethodCaptureEnum {
	REQUIRE = 'require',
	ASK = 'ask',
	NONE = 'none',
}

export interface Organization {
	id?: number;
	name?: string;
	email?: string;
	twitter?: string;
	facebook?: string;
	instagram?: string;
	phoneNumber?: string;
	waiverDoc?: string;
	about?: string;
	tagline?: string;
	address?: OrganizationAddress;
	status?: number;
	addressId?: number;
	merchantId?: number;
	userCreatorId?: number;
	paymentSettings?: PaymentSettings;
	isClaimed?: boolean;
	sports?: number[];
	mainMedia?: Media;
	logo?: MediaItem;
	organizationGenders?: number;
	questionnaireId?: number;
	membershipQuestionnaireId?: number;
	colorCodes?: ColorCode[];
	currency?: CurrencyEnum;
	settings?: OrganizationSettings;
	timezone?: string;
	GA4MeasurementId?: string;
	GTMContainerId?: string;
}

/**
 * Same shape as IInvoiceSettings in @bondsports/types once BOND-20811 is published.
 * Swap this for that export when the package is bumped.
 */
export interface IInvoiceCustomText {
	body?: string;
	enabled?: boolean;
	title?: string;
}

export interface IInvoiceTaxRegistration {
	code: string;
	name: string;
}

export interface IInvoiceSettings {
	customText?: IInvoiceCustomText;
	taxRegistrations?: IInvoiceTaxRegistration[];
}

export interface OrganizationSettings {
	autopopulateDuration: number;
	invoiceSettings?: IInvoiceSettings | null;
}

export interface Questionnaires {
	id: number;
	organizationId: number;
	title: string;
	createdAt: Date;
	updatedAt: Date;
}

export interface IGetGlCodesQuery {
	resourceTypes?: GlResourceTypeEnum[];
	productTypes?: ProductTypesEnum[];
	isResourceTypeNullable?: boolean;
	glIds?: (number | string)[];
}
